import { currentLocale } from '@/app/i18n'
import { crispAvailable, openCrispChat } from '@/app/integrations/crisp'
import type { DropdownAction } from '@/shared/ui/AppDropdownActions.vue'

type Translate = (key: 'shell.navbar.menu.supportArticles' | 'shell.navbar.menu.liveChat') => string

/** The Help Center (help/, 2026-11): it replaced the WordPress hub (hub.skileo.com). */
const HELP_CENTER = 'https://www.skileo.com/help'

/** The app's legacy locale codes the Help Center writes the standard way (help/config.mjs `LANGUAGES`). */
const HELP_CODES: Readonly<Record<string, string>> = { cz: 'cs', gr: 'el' }

/** The Help Center home in `locale` (the UI language by default): `/help/fr/`, `/help/cs/` for the app's `cz`. */
export function helpCenterUrl(locale: string = currentLocale()): string {
  return `${HELP_CENTER}/${HELP_CODES[locale] ?? locale}/`
}

/**
 * The help entries (wp/shell §4.16): the Help Center in the UI language and, when Crisp is loaded, the live chat.
 * Shared by the navbar's help menu (below 1200 px) and the vertical nav's account card.
 */
export function helpActions(t: Translate): DropdownAction[] {
  return [
    {
      id: 'support',
      label: t('shell.navbar.menu.supportArticles'),
      icon: 'HelpCircleIcon',
      href: helpCenterUrl(),
      target: '_blank',
    },
    ...(crispAvailable()
      ? [{ id: 'chat', label: t('shell.navbar.menu.liveChat'), icon: 'MessageSquareIcon', onSelect: openCrispChat }]
      : []),
  ]
}
